import { createSelector } from 'reselect';

export const getDevicesAccesor = state => state.stock.devices;

export const devicesSelector = createSelector(getDevicesAccesor, state => state);

export const devicesSubstatusesSelector = createSelector(
  getDevicesAccesor,
  state => state.substatuses || []
);

export const devicesSubstatusesFetchingSelector = createSelector(
  getDevicesAccesor,
  state => state.substatusesFetching || false
);
